import React from 'react'
import { InputGuesser } from '@api-platform/admin'
import {
  required,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  TextInput,
} from 'react-admin'
import { CreateGuesser } from 'theme/components'

export const ProductStoreIntervalCreate = (props) => (
  <CreateGuesser {...props} variant="outlined" redirect="list">
    <ReferenceInput
      source="productStore"
      reference="product-stores"
      label="resources.productStore.field"
      filterToQuery={(searchText) => ({ sku: searchText })}
      format={(v) => (v && v['@id'] ? v['@id'] : v)}
    >
      <AutocompleteInput
        optionText={(option) => {
          if (!option) return option?.sku
          return `${option.sku} (${option?.store?.name})`
        }}
        validate={required()}
      />
    </ReferenceInput>
    <ReferenceInput
      source="interval"
      reference="intervals"
      label="resources.interval.field"
      filterToQuery={(searchText) => ({ name: searchText })}
      format={(v) => (v && v['@id'] ? v['@id'] : v)}
    >
      <AutocompleteInput optionText="name" resettable />
    </ReferenceInput>
    <ReferenceInput
      source="currency"
      reference="currencies"
      label="resources.currency.field"
      format={(v) => (v && v['@id'] ? v['@id'] : v)}
    >
      <SelectInput optionText="code" validate={required()} />
    </ReferenceInput>
    <ReferenceInput
      source="pricingModel"
      reference="pricing-models"
      label="resources.productStoreInterval.pricingModel"
      format={(v) => (v && v['@id'] ? v['@id'] : v)}
    >
      <SelectInput optionText="slug" validate={required()} />
    </ReferenceInput>
    <InputGuesser source="chargeBeeId" label="resources.order.chargeBee" />
    <InputGuesser source="name" inputProps={{ maxLength: 50 }} />
    <InputGuesser source="invoiceName" inputProps={{ maxLength: 100 }} />
    <TextInput source="invoiceNotes" inputProps={{ maxLength: 2000 }} />
    <InputGuesser source="price" />
    <InputGuesser source="qty" />
    <InputGuesser source="shippable" />
    <InputGuesser source="enabledInPortal" defaultValue={true} />
    <InputGuesser source="description" />
  </CreateGuesser>
)
